export const preferenceKeys = {
  all: ['preferences'] as const,
  user: (userId: number) => [...preferenceKeys.all, 'user', userId] as const,
  dish: (dishId: number) => [...preferenceKeys.all, 'dish', dishId] as const,
  ingredient: (productId: number) =>
    [...preferenceKeys.all, 'ingredient', productId] as const,
};
